import { render } from "./chatlist.vue?vue&type=template&id=16e09b68"
import script from "./chatlist.vue?vue&type=script&lang=js"
export * from "./chatlist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__